import { useQuery, useMutation } from '@apollo/client';
import { GET_MY_SETTINGS, GET_OOF_MODE, UPDATE_OOF_MODE, UPDATE_MY_PROFILE } from '../services/graphql';
import { useDispatch } from "react-redux";
import {
  userLoginSuccess,
  userLoginError,
} from "../store/actions/graphqlActions";
import keycloak from "../keycloak";

const resolveCurrentEmail = () => keycloak?.tokenParsed?.email || sessionStorage.getItem("email") || null;
const useSettingsQuery = () => {
  const dispatch = useDispatch();
  
  const { 
    loading: settingsLoading, 
    error: settingsError, 
    data: settingsData, 
    refetch: settingsRefetch 
  } = useQuery(GET_MY_SETTINGS, {
    variables: { email: keycloak.tokenParsed?.email },
    fetchPolicy: 'network-only', // Always fetch fresh data
  });

  const { 
    loading: oofLoading, 
    error: oofError, 
    data: oofData, 
    refetch: oofRefetch 
  } = useQuery(GET_OOF_MODE, {
    variables: { email: keycloak.tokenParsed?.email },
  });

  // Mutation for updating settings
  const [updateProfile] = useMutation(UPDATE_MY_PROFILE, {
    refetchQueries: [
      { 
        query: GET_MY_SETTINGS, 
        variables: { email: keycloak.tokenParsed?.email  } 
      }
    ],
    awaitRefetchQueries: true,
    onCompleted: (data) => {
      console.log('Settings update completed:', data); // DEBUG
      const status = data.modifyUserProfile.status;
      if (status.authorized) {
        localStorage.setItem("authorized", status.authorized);
        localStorage.setItem("access_level", status.accessLevel);
        dispatch(userLoginSuccess({ email: resolveCurrentEmail() }));
      } else {
        dispatch(userLoginError());
      }
    },
    onError: (error) => {
      console.error('Settings update error:', error); // DEBUG
    }
  });

  // Function to update settings (darkMode, tableDensity, timeZone)
  const updateSettings = async (changes) => {
    try {
      const email = keycloak.tokenParsed?.email; ;
      console.log('Updating settings:', { email, changes }); // DEBUG
      
      const { data } = await updateProfile({ 
        variables: { 
          userEmail: email, 
          modification: changes 
        } 
      });
      
      console.log('Settings update response:', data); // DEBUG
      console.log('Updated body:', data?.modifyUserProfile?.body); // DEBUG
      
      // Force refetch to verify data was saved
      await settingsRefetch();
      
      return data;
    } catch (error) {
      console.error('updateSettings error:', error); // DEBUG
      console.error('Error details:', error.graphQLErrors); // DEBUG
      console.error('Network error:', error.networkError); // DEBUG
      throw error;
    }
  };

  const [updateOOF] = useMutation(UPDATE_OOF_MODE, {
    onCompleted: (data) => {
      const status = data.changeApproverOutOfOffice.status;
      if (status.authorized) {
        localStorage.setItem("authorized", status.authorized);
        localStorage.setItem("access_level", status.accessLevel);
        dispatch(userLoginSuccess({ email: resolveCurrentEmail() }));
      } else {
        dispatch(userLoginError());
      }
    }
  });

  const updateOOFmode = async (newOutOfOffice) => {   
    try {
      const { data } = await updateOOF({ 
        variables: { 
          oldOutOfOffice: !newOutOfOffice, 
          newOutOfOffice: newOutOfOffice 
        } 
      });
    } catch (error) {
      console.error(error);
      alert("Failed to update Out of Office mode. Please try again.");
    }
  };

  return {
    settingsLoading, 
    settingsData, 
    settingsRefetch, 
    oofLoading, 
    oofData, 
    oofRefetch, 
    updateOOFmode,
    updateSettings // NEW: Export the settings update function
  };
};

export default useSettingsQuery;